import { useCallback, useState, type ReactNode } from "react";
import type { TrainingSessionListView } from "@/api";
import { RightSidePanel } from "@/components/modal";
import { SessionComparisonViewer } from "./SessionComparisonViewer";
import { DEFAULT_COMPARE_METRIC_KEYS } from "./sessionCompareModel";
import { useSessionCompareController } from "./useSessionCompareController";

// 학습 세션 비교 side panel. SubmitSessionsPanel 의 로컬 상태가 소유한다. 마운트 = 열림이다.
// 닫으면 언마운트되어 로드한 비교 데이터와 지표 선택을 버린다. 목록 행 스냅샷(sessions)을 받아
// 상세가 도착하기 전에 범례와 상태 칩을 표시한다. 색 슬롯은 여는 시점에 고정한 slotById 를 쓴다.
export function SessionComparePanel({
  sessions,
  slotById,
  onClose,
}: {
  sessions: readonly TrainingSessionListView[];
  slotById: Readonly<Record<string, number>>;
  onClose: () => void;
}): ReactNode {
  const [selectedKeys, setSelectedKeys] = useState<readonly string[]>(DEFAULT_COMPARE_METRIC_KEYS);
  const controller = useSessionCompareController(sessions, { enabled: true, selectedKeys });

  const toggleKey = useCallback((key: string) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key],
    );
  }, []);

  return (
    <RightSidePanel
      title={`Training Session 비교 · ${sessions.length}개`}
      width={{ kind: "flex", percent: 80 }}
      onBackdrop={onClose}
      onRequestClose={onClose}
    >
      {/* 창 프레임·본문 여백·스크롤은 셸이 소유한다. 뷰어는 자연 높이 행이다. */}
      <SessionComparisonViewer
        sessions={sessions}
        slotById={slotById}
        controller={controller}
        selectedKeys={selectedKeys}
        onToggleKey={toggleKey}
      />
    </RightSidePanel>
  );
}
